<template>
<div id="page-user-list" style="margin-top: -25px;">
    <div class="vx-card p-6">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 mt-2 w-full">
          <span class="title-page">{{$t('warningManager.allNotification')}}</span>
        </div>
        <!-- <div class="vx-col md:w-1/2 mt-2 w-full">
          <vs-button style="float:right" class="" icon="icon-plus" icon-pack="feather">Tạo thông báo mới</vs-button>
        </div> -->
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/6 mt-2" v-for="item in optionalTitle">
          <span class="count-noti ml-2">{{item.label}}: {{item.value || 0}}</span>
        </div>
      </div>
    </div>
    <vx-card class="mt-2">
      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full mt-2">
          <span class="header-table">{{$t('warningManager.timeNotification')}}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2">
          <span class="header-table">{{$t('warningManager.contentNotification')}}</span>
        </div>

        <div class="vx-col md:w-1/6 w-full mt-2">
          <span class="header-table">{{$t('warningManager.source')}}</span>
        </div>

        <div class="vx-col md:w-1/6 w-full mt-2">
          <span class="header-table">{{$t('warningManager.transactions')}}</span>
        </div>
      </div>
      <div class="vx-row mt-2 cursor-pointer" v-for="item in responseData" @click="notificationSeen(item)">
        <div class="vx-col md:w-1/6 w-full mt-2">
          <span :class="{'color-content' :item.seenStatus == 0}">
            {{item.created}}
          </span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2">
          <div class="vx-row">
            <span :class="{'color-content' :item.seenStatus == 0}">{{item.title}}</span>
            <vs-button v-if="item.seenStatus == 0" class="save-status ml-4" icon="icon" icon-pack="feather">new</vs-button>
          </div>
        </div>

        <div class="vx-col md:w-1/6 w-full mt-2">
          <span :class="{'color-content' :item.seenStatus == 0}">{{item.createdBy}}</span>
        </div>

        <div class="vx-col md:w-1/6 w-full mt-2">
          <div class="vx-row">
            <vs-button v-if="item.saveNotification == 0 || !item.saveNotification" class="ml-4 save-noti" icon="icon-plus" icon-pack="feather" @click="saveNotification(item)">Lưu</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
</div>
</template>
<script>
import moment from 'moment';
export default {
components:{
  moment
},
data(){
  return{
    optionalTitle:[
      {label:'Cảnh báo mới', value:0},
      {label:'Tất cả cảnh báo', value:1},
      {label:'Lưu trữ cảnh báo', value:2}
    ],
    responseData:[]
  }
},
methods:{
  i18nOptionalTitle : function () {
    this.optionalTitle[0].label = this.$t('warningManager.newWarning')
    this.optionalTitle[1].label = this.$t('warningManager.allWarningMessage')
    this.optionalTitle[2].label = this.$t('warningManager.storageWarning')
  },
  getListNofitication: function(){
    const payload ={
      start:0,
      length:10
    }
    this.$business.post('notification/list', payload).then((res) =>{
      const data = res.data;
      const countNewNotifi = data.filter(el => el.seenStatus == 0);
      const countSaveNotifi = data.filter(el => el.saveNotification == 1);
      this.optionalTitle[0].value = countNewNotifi.length;
      this.optionalTitle[1].value = data.length;
      this.optionalTitle[2].value = countSaveNotifi.length;
      data.forEach(el =>{
        el.created = moment(el.createdDate).format('DD/MM/YYYY HH:mm:ss');
        const createdBy= JSON.parse(el.body);
        el.createdBy = createdBy.params.createdBy;
      })
      this.responseData = res.data;
    })
  },
  notificationSeen:function(event){
    this.$vs.loading();
    if(event && event.id){
      this.$business.post(`/notification/seen/` + event.id).then(() =>{
        this.$vs.loading.close();
        this.getListNofitication();
      }).catch((err) =>{
        this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
    }

  },
  saveNotification: function(event){
    this.$vs.loading();
    const payload ={
      id:event.id
    }
    this.$business.post(`notification/save-notification`, payload).then(() =>{
      this.$vs.loading.close();
      return this.$vs.notify({
        text:this.$t('warningManager.text8'),
        icon:'icon-alert',
        iconPack:'feather',
        color:'primary'
      })
    }).catch((err) =>{
      return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
    })
  },
  initScreen(){
    this.getListNofitication();
  }
},
async created(){
  this.initScreen();
  this.$eventBus.$on('i18n', () => {
    this.i18nOptionalTitle();
  })
  this.i18nOptionalTitle()
  this.$messaging.onMessage( (payload)  =>{
        // if (payload.data.type != "user") return
        // this.selectedNtf = payload;
        setTimeout(()=>{
          this.getListNofitication()
          }, 1000)
        return this.$vs.notify({
            text: payload.notification.title,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'primary',
            click: this.openUrlInPopup

          });
      });
}
}
</script>
<style scoped>
.save-noti{
  border-radius: 20px;
  width: 20px;
  height: 20px;
}
.save-status{
  background-color: red !important;
  border-radius: 20px;
  width: 15px;
  height: 20px;
}
.color-content{
  color: #277df6;
  font-weight: bold;
}
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
.header-table{
  font-weight: bold;
  font-size: 18px;
}
.count-noti{
  font-size: 12px;
}
</style>
